export const signalRConnectionIdKey = 'signalr-connection-id';
